import { connect } from 'react-redux';
import UpdateGarage from 'components/garages/UpdateGarage';
import { updateGarage } from 'data/garages/Garages.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) => {
  return ReduxHelper.mapStateWithLookups(
    {
      lang: state.i18n.locale,
      garage: state.garages.currentGarage,
    },
    state,
    'countries',
    'regions',
    'taxOffices',
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: garageData => dispatch(updateGarage(garageData)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(UpdateGarage);
